// extracted by mini-css-extract-plugin
export default {"toggleBtn":"aboutus_toggleBtn__Wx-nx","active":"aboutus_active__aPJNh","contentBox":"aboutus_contentBox__gkvfZ","aboutUsTagline":"aboutus_aboutUsTagline__6nDXP"};